'use client';

import { Box } from '@terra/ui-styled-system';

/**
 * A small animated green dot indicating "live" status.
 * Used in tool card headers for active listeners.
 */
export function LiveDot() {
  return (
    <Box
      w="6px"
      h="6px"
      borderRadius="full"
      bg="green.9"
      animation="pulse 2s ease-in-out infinite"
      flexShrink={0}
    />
  );
}
